import { IpaginatedSeccionsocios, ISeccionsociosItem } from '../models'

export enum SeccionsociosActionTypes {
  SEARCH_SECCIONSOCIOS = 'seccionsocios/search',
  SEARCHING_SECCIONSOCIOS = 'seccionsocios/searching',
  FOUND_SECCIONSOCIOS = 'seccionsocios/found',
  SEARCHING_SECCIONSOCIOS_FAILED = 'seccionsocios/searching_failed',

  LOAD_SECCIONSOCIOS = 'seccionsocios/load',
  LOADING_SECCIONSOCIOS = 'seccionsocios/loading',
  LOADED_SECCIONSOCIOS = 'seccionsocios/loaded',
  LOADING_SECCIONSOCIOS_FAILED = 'seccionsocios/loading_failed',

  ADD_SECCIONSOCIOS = 'seccionsocios/add',
  ADDING_SECCIONSOCIOS = 'seccionsocios/adding',
  ADDED_SECCIONSOCIOS = 'seccionsocios/added',
  ADDING_SECCIONSOCIOS_FAILED = 'seccionsocios/adding_failed',

  REMOVE_SECCIONSOCIO = 'seccionsocios/remove',
  REMOVING_SECCIONSOCIO = 'seccionsocios/removing',
  REMOVED_SECCIONSOCIO = 'seccionsocios/removed',
  REMOVING_SECCIONSOCIO_FAILED = 'seccionsocios/removing_failed',

  SOFT_REMOVE_SECCIONSOCIOS = 'seccionsocios/soft_remove',
  SOFT_REMOVING_SECCIONSOCIOS = 'seccionsocios/soft_removing',
  SOFT_REMOVED_SECCIONSOCIOS = 'seccionsocios/soft_removed',
  SOFT_REMOVING_SECCIONSOCIOS_FAILED = 'seccionsocios/soft_removing_failed',

  EDIT_SECCIONSOCIOS = 'seccionsocios/edit',
  EDITING_SECCIONSOCIOS = 'seccionsocios/editing',
  EDITED_SECCIONSOCIOS = 'seccionsocios/edited',
  EDITING_SECCIONSOCIOS_FAILED = 'seccionsocios/editing_failed',

  VIEW_SECCIONSOCIOS = 'seccionsocios/view',
  VIEWING_SECCIONSOCIOS = 'seccionsocios/viewing',
  VIEWED_SECCIONSOCIOS = 'seccionsocios/viewed',
  VIEWING_SECCIONSOCIOS_FAILED = 'seccionsocios/viewing_failed',
}

export function searchSeccionsocios(searchOptions: TSearchOptions | string, keep?: boolean): ISearchSeccionsociosAction {
  return {
    type: SeccionsociosActionTypes.SEARCH_SECCIONSOCIOS,
    searchOptions: typeof searchOptions === 'string' ? { searchString: searchOptions } : searchOptions,
    keep: keep,
  }
}

export function searchingSeccionsocios(): ISearchingSeccionsociosAction {
  return {
    type: SeccionsociosActionTypes.SEARCHING_SECCIONSOCIOS,
  }
}

export function foundSeccionsocios(seccionsocios: IpaginatedSeccionsocios, keep?: boolean): IFoundSeccionsociosAction {
  return {
    type: SeccionsociosActionTypes.FOUND_SECCIONSOCIOS,
    keep: keep,
    payload: {
      seccionsocios,
    },
  }
}

export function searchingSeccionsociosFailed(): ISearchingSeccionsociosFailedAction {
  return {
    type: SeccionsociosActionTypes.SEARCHING_SECCIONSOCIOS_FAILED,
  }
}

export function loadSeccionsocios(loadOptions: TSearchOptions): ILoadSeccionsociosAction {
  return {
    type: SeccionsociosActionTypes.LOAD_SECCIONSOCIOS,
    loadOptions: loadOptions,
  }
}

export function loadingSeccionsocios(): ILoadingSeccionsociosAction {
  return {
    type: SeccionsociosActionTypes.LOADING_SECCIONSOCIOS,
  }
}

export function loadedSeccionsocios(seccionsocios: IpaginatedSeccionsocios): ILoadedSeccionsociosAction {
  return {
    type: SeccionsociosActionTypes.LOADED_SECCIONSOCIOS,
    payload: {
      seccionsocios,
    },
  }
}

export function loadingSeccionsociosFailed(): ILoadingSeccionsociosFailedAction {
  return {
    type: SeccionsociosActionTypes.LOADING_SECCIONSOCIOS_FAILED,
  }
}

export function addSeccionsocios(seccionsocio: ISeccionsociosItem): IAddSeccionsociosAction {
  return {
    type: SeccionsociosActionTypes.ADD_SECCIONSOCIOS,
    payload: seccionsocio,
  }
}

export function addingSeccionsocios(): IAddingSeccionsociosAction {
  return {
    type: SeccionsociosActionTypes.ADDING_SECCIONSOCIOS,
  }
}

export function addedSeccionsocios(seccionsocios: IpaginatedSeccionsocios): IAddedSeccionsociosAction {
  return {
    type: SeccionsociosActionTypes.ADDED_SECCIONSOCIOS,
    payload: {
      seccionsocios,
    },
  }
}

export function addingSeccionsociosFailed(errData: { data: { message: string; field?: string }; status: number }): IAddingSeccionsociosFailedAction {
  return {
    type: SeccionsociosActionTypes.ADDING_SECCIONSOCIOS_FAILED,
    message: errData.data.message,
    status: errData.status,
    field: errData.data.field,
  }
}

export function removeSeccionsocio(seccionsocio: ISeccionsociosItem): IRemoveSeccionsocioAction {
  return {
    type: SeccionsociosActionTypes.REMOVE_SECCIONSOCIO,
    payload: seccionsocio,
  }
}

export function removingSeccionsocio(): IRemovingSeccionsocioAction {
  return {
    type: SeccionsociosActionTypes.REMOVING_SECCIONSOCIO,
  }
}

export function removedSeccionsocio(): IRemovedSeccionsocioAction {
  return {
    type: SeccionsociosActionTypes.REMOVED_SECCIONSOCIO,
  }
}

export function removingSeccionsocioFailed(): IRemovingSeccionsocioFailedAction {
  return {
    type: SeccionsociosActionTypes.REMOVING_SECCIONSOCIO_FAILED,
  }
}

export function softRemoveSeccionsocios(seccionsocio: ISeccionsociosItem): ISoftRemoveSeccionsociosAction {
  return {
    type: SeccionsociosActionTypes.SOFT_REMOVE_SECCIONSOCIOS,
    payload: seccionsocio,
  }
}

export function softRemovingSeccionsocios(): ISoftRemovingSeccionsociosAction {
  return {
    type: SeccionsociosActionTypes.SOFT_REMOVING_SECCIONSOCIOS,
  }
}

export function softRemovedSeccionsocios(seccionsocio: ISeccionsociosItem): ISoftRemovedSeccionsociosAction {
  return {
    type: SeccionsociosActionTypes.SOFT_REMOVED_SECCIONSOCIOS,
    payload: seccionsocio,
  }
}

export function softRemovingSeccionsociosFailed(errData: {
  data: { message: string; field?: string }
  status: number
}): ISoftRemovingSeccionsociosFailedAction {
  return {
    type: SeccionsociosActionTypes.SOFT_REMOVING_SECCIONSOCIOS_FAILED,
    message: errData.data.message,
    status: errData.status,
    field: errData.data.field,
  }
}

export function editSeccionsocios(seccionsocio: ISeccionsociosItem): IEditSeccionsociosAction {
  return {
    type: SeccionsociosActionTypes.EDIT_SECCIONSOCIOS,
    payload: seccionsocio,
  }
}

export function editingSeccionsocios(): IEditingSeccionsociosAction {
  return {
    type: SeccionsociosActionTypes.EDITING_SECCIONSOCIOS,
  }
}

export function editedSeccionsocios(seccionsocios: ISeccionsociosItem): IEditedSeccionsociosAction {
  return {
    type: SeccionsociosActionTypes.EDITED_SECCIONSOCIOS,
    payload: seccionsocios,
  }
}

export function editingSeccionsociosFailed(errData: {
  data: { message: string; field?: string }
  status: number
}): IEditingSeccionsociosFailedAction {
  return {
    type: SeccionsociosActionTypes.EDITING_SECCIONSOCIOS_FAILED,
    message: errData.data.message,
    status: errData.status,
    field: errData.data.field,
  }
}

export function viewSeccionsocios(seccionsocio: ISeccionsociosItem): IViewSeccionsociosAction {
  return {
    type: SeccionsociosActionTypes.VIEW_SECCIONSOCIOS,
    payload: seccionsocio,
  }
}

export function viewingSeccionsocios(): IViewingSeccionsociosAction {
  return {
    type: SeccionsociosActionTypes.VIEWING_SECCIONSOCIOS,
  }
}

export function viewedSeccionsocios(seccionsocios: ISeccionsociosItem): IViewedSeccionsociosAction {
  return {
    type: SeccionsociosActionTypes.VIEWED_SECCIONSOCIOS,
    payload: seccionsocios,
  }
}

export function viewingSeccionsociosFailed(): IViewingSeccionsociosFailedAction {
  return {
    type: SeccionsociosActionTypes.VIEWING_SECCIONSOCIOS_FAILED,
  }
}

type TSearchOptions = {
  searchString?: string
  searchField?: string
  page?: number
  limit?: number
  populate?: boolean
  sort?: {
    field: string
    method?: 'asc' | 'desc'
  }
  filters?: { field: string; value: string }[]
}

export interface ISearchSeccionsociosAction {
  type: SeccionsociosActionTypes.SEARCH_SECCIONSOCIOS
  searchOptions: TSearchOptions
  keep?: boolean
}

export interface ISearchingSeccionsociosAction {
  type: SeccionsociosActionTypes.SEARCHING_SECCIONSOCIOS
}

export interface IFoundSeccionsociosAction {
  type: SeccionsociosActionTypes.FOUND_SECCIONSOCIOS
  keep?: boolean
  payload: {
    seccionsocios: IpaginatedSeccionsocios
  }
}

export interface ISearchingSeccionsociosFailedAction {
  type: SeccionsociosActionTypes.SEARCHING_SECCIONSOCIOS_FAILED
}

export interface ILoadSeccionsociosAction {
  type: SeccionsociosActionTypes.LOAD_SECCIONSOCIOS
  loadOptions: TSearchOptions
}

export interface ILoadingSeccionsociosAction {
  type: SeccionsociosActionTypes.LOADING_SECCIONSOCIOS
}

export interface ILoadedSeccionsociosAction {
  type: SeccionsociosActionTypes.LOADED_SECCIONSOCIOS
  payload: {
    seccionsocios: IpaginatedSeccionsocios
  }
}

export interface ILoadingSeccionsociosFailedAction {
  type: SeccionsociosActionTypes.LOADING_SECCIONSOCIOS_FAILED
}

export interface IAddSeccionsociosAction {
  type: SeccionsociosActionTypes.ADD_SECCIONSOCIOS
  payload: ISeccionsociosItem
}

export interface IAddingSeccionsociosAction {
  type: SeccionsociosActionTypes.ADDING_SECCIONSOCIOS
}

export interface IAddedSeccionsociosAction {
  type: SeccionsociosActionTypes.ADDED_SECCIONSOCIOS
  payload: {
    seccionsocios: IpaginatedSeccionsocios
  }
}

export interface IAddingSeccionsociosFailedAction {
  type: SeccionsociosActionTypes.ADDING_SECCIONSOCIOS_FAILED
  message: string
  status: number
  field?: string
}

export interface IRemoveSeccionsocioAction {
  type: SeccionsociosActionTypes.REMOVE_SECCIONSOCIO
  payload: ISeccionsociosItem
}

export interface IRemovingSeccionsocioAction {
  type: SeccionsociosActionTypes.REMOVING_SECCIONSOCIO
}

export interface IRemovedSeccionsocioAction {
  type: SeccionsociosActionTypes.REMOVED_SECCIONSOCIO
}

export interface IRemovingSeccionsocioFailedAction {
  type: SeccionsociosActionTypes.REMOVING_SECCIONSOCIO_FAILED
}

export interface ISoftRemoveSeccionsociosAction {
  type: SeccionsociosActionTypes.SOFT_REMOVE_SECCIONSOCIOS
  payload: ISeccionsociosItem
}

export interface ISoftRemovingSeccionsociosAction {
  type: SeccionsociosActionTypes.SOFT_REMOVING_SECCIONSOCIOS
}

export interface ISoftRemovedSeccionsociosAction {
  type: SeccionsociosActionTypes.SOFT_REMOVED_SECCIONSOCIOS
  payload: ISeccionsociosItem
}

export interface ISoftRemovingSeccionsociosFailedAction {
  type: SeccionsociosActionTypes.SOFT_REMOVING_SECCIONSOCIOS_FAILED
  message: string
  status: number
  field?: string
}

export interface IEditSeccionsociosAction {
  type: SeccionsociosActionTypes.EDIT_SECCIONSOCIOS
  payload: ISeccionsociosItem
}

export interface IEditingSeccionsociosAction {
  type: SeccionsociosActionTypes.EDITING_SECCIONSOCIOS
}

export interface IEditedSeccionsociosAction {
  type: SeccionsociosActionTypes.EDITED_SECCIONSOCIOS
  payload: ISeccionsociosItem
}

export interface IEditingSeccionsociosFailedAction {
  type: SeccionsociosActionTypes.EDITING_SECCIONSOCIOS_FAILED
  message: string
  status: number
  field?: string
}

export interface IViewSeccionsociosAction {
  type: SeccionsociosActionTypes.VIEW_SECCIONSOCIOS
  payload: ISeccionsociosItem
}

export interface IViewingSeccionsociosAction {
  type: SeccionsociosActionTypes.VIEWING_SECCIONSOCIOS
}

export interface IViewedSeccionsociosAction {
  type: SeccionsociosActionTypes.VIEWED_SECCIONSOCIOS
  payload: ISeccionsociosItem
}

export interface IViewingSeccionsociosFailedAction {
  type: SeccionsociosActionTypes.VIEWING_SECCIONSOCIOS_FAILED
}

export type SeccionsociosAction =
  | ISearchSeccionsociosAction
  | ISearchingSeccionsociosAction
  | IFoundSeccionsociosAction
  | ISearchingSeccionsociosFailedAction
  | ILoadSeccionsociosAction
  | ILoadingSeccionsociosAction
  | ILoadedSeccionsociosAction
  | ILoadingSeccionsociosFailedAction
  | IAddSeccionsociosAction
  | IAddingSeccionsociosAction
  | IAddedSeccionsociosAction
  | IAddingSeccionsociosFailedAction
  | IRemoveSeccionsocioAction
  | IRemovingSeccionsocioAction
  | IRemovedSeccionsocioAction
  | IRemovingSeccionsocioFailedAction
  | ISoftRemoveSeccionsociosAction
  | ISoftRemovingSeccionsociosAction
  | ISoftRemovedSeccionsociosAction
  | ISoftRemovingSeccionsociosFailedAction
  | IEditSeccionsociosAction
  | IEditingSeccionsociosAction
  | IEditedSeccionsociosAction
  | IEditingSeccionsociosFailedAction
  | IViewSeccionsociosAction
  | IViewingSeccionsociosAction
  | IViewedSeccionsociosAction
  | IViewingSeccionsociosFailedAction
